<template>
	<div>
		<div class="box">
			<div class="container" style="padding: 54px 0 30px;">
				<div class="flex ali-cen">
					<img src="../images/logo2.png" alt="">
					<div class="btn" @click="k_maiBnt">康买故事</div>
				</div>
				<div class="con flex ">
					<div class="item" v-for="(item,index) in bottomList" :key="index">
						<div class="title">
							{{item.title}}
						</div>
						<div class="text" @click="Bbtn(index,item1.richtext_id)" v-for="item1 in item.children" :key="item1.richtext_id">{{item1.title}}</div>
					</div>


				</div>
			</div>
		</div>
	<a href="https://beian.miit.gov.cn/"><div class="bottom">沪ICP备10209911号-1 沪公网安备 310 10902001729号</div></a>
	</div>
</template>
<script>
import {indexHelp} from '@/api/index.js'
	export default{
		data(){
			return{
            bottomList:[]
			}
		},
		methods:{
        Bbtn(index,item1){
        console.log(index);
        console.log(item1);

        this.$router.push({path:'/help',query:{id:item1,rich_id:index}})
        },
        getIndexHelp(){
        indexHelp({}).then(res=>{
            console.log(res);
            this.bottomList = res.data.list
        })
        },
        k_maiBnt(){
        this.$router.push({path:'/company'})
        }

		},
		props:{

		},
		watch:{

		},
		created() {

        },
        mounted(){
            setTimeout(()=>{
                this.getIndexHelp()
            },1000)

        }
	}
</script>
<style lang="less" scoped>
	.box{
		background-color: #0070BE;
		height: 391px;
		margin-top: 100px;
	}
	.bottom{

		font-size: 14px;
		color: #fff;
		height: 47px;
		line-height: 47px;
		background: #014576;
		text-align: center;
    }
    .flex{
        display: flex;
        justify-content: space-evenly;
    }
	.btn{
		width: 139px;
		height: 43px;
		background: #FF6701;
		line-height: 43px;
		color: #fff;
		text-align: center;
		margin-left: 160px;
	}
	.item{
		// width: 200px;
		color: #fff;
		margin-top: 40px;
		.title{
			font-size: 18px;
			margin-bottom: 10px;
		}
		.text{
			font-size: 14px;
			height: 30px;
            line-height: 30px;
            cursor: pointer;
		}
	}
	a{
		text-decoration: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/bottom.vue